module.exports = __webpack_public_path__ + "static/Palette-f207692d812cdb19771d29dc5f86304e.png";